export default __webpack_public_path__ + "static/media/power.eff14ca1.svg";